import * as Label from '@radix-ui/react-label'
import * as React from 'react'
import { cn } from '../../utils/cn'
import { useFieldContext } from './field-context'

export function FieldLabel({ className, ...props }: FieldLabel.Props) {
  const { size } = useFieldContext()
  return (
    <span
      className={cn(
        'font-semibold text-gray-900',
        size === 'sm' && 'text-xs',
        size === 'md' && 'text-sm',
        className
      )}
      data-slot="field-label"
    >
      <Label.Root {...props} />
    </span>
  )
}

export namespace FieldLabel {
  export interface Props extends React.ComponentProps<typeof Label.Root> {}
}
